import { Suspense, useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { setOptions } from "@googlemaps/js-api-loader";

// import { useSelector } from "react-redux";

import router from "@router/rutas";
// import { RootState, store } from "@store/store";

import "./declarations.d.ts";

import "./App.css";

function App() {
    // const permissions = (state = store.getState()) => state.app.session.permissions;
    // const authState = useSelector((state: RootState) => state.auth);

    useEffect(() => {
        setOptions({
            key: import.meta.env.VITE_GMAPS,
        });
    }, []);

    return (
        <Suspense fallback={<></>}>
            <RouterProvider router={router} />
        </Suspense>
    );
}

export default App;
